// src/redux/workflows/slice.ts

import { createSlice } from '@reduxjs/toolkit';
import { WorkflowsState } from './types';
import {
  fetchForms,
  fetchFormDetails,
  fetchFormGroups,
  fetchFormGroupInstance,
  fetchFormGroupInstanceDetails,
} from './thunk';

const initialState: WorkflowsState = {
  forms: [],
  formDetails: null,
  formGroups: [],
  formGroupInstance: null,
  formGroupInstanceDetails: null,
  status: 'idle',
  error: null,
};

const workflowsSlice = createSlice({
  name: 'workflows',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Get Forms
      .addCase(fetchForms.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchForms.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.forms = action.payload;
      })
      .addCase(fetchForms.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Failed to fetch forms';
      })

      // Get Form Details
      .addCase(fetchFormDetails.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchFormDetails.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.formDetails = action.payload;
      })
      .addCase(fetchFormDetails.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Failed to fetch form details';
      })

      // Get Form Groups
      .addCase(fetchFormGroups.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchFormGroups.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.formGroups = action.payload;
      })
      .addCase(fetchFormGroups.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Failed to fetch form groups';
      })

      // Get Form Group Instance
      .addCase(fetchFormGroupInstance.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchFormGroupInstance.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.formGroupInstance = action.payload;
      })
      .addCase(fetchFormGroupInstance.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Failed to fetch form group instance';
      })

      // Get Form Group Instance Details
      .addCase(fetchFormGroupInstanceDetails.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchFormGroupInstanceDetails.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.formGroupInstanceDetails = action.payload;
      })
      .addCase(fetchFormGroupInstanceDetails.rejected, (state, action) => {
        state.status = 'failed';
        state.error =
          action.payload || 'Failed to fetch form group instance details';
      });
  },
});

export default workflowsSlice.reducer;
